import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const OfficialCalendar = () => {
  const navigate = useNavigate();

  const [tableData, setTableData] = useState([]);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchCases = async () => {
      try {
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };

        const response = await fetch(
          "https://admindashboard.clns.in/api/dashboard/official/get_availability/",
          {
            method: "GET",
            headers: headers,
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        setTableData(data);
      } catch (error) {
        console.error("Error fetching cases:", error);
      }
    };

    fetchCases();
  }, [token]);

  console.log(tableData, "cehck");

  // const calendarData = [
  //   {
  //     officialName: "Jabili",
  //     officialId: "ef1234",
  //     phoneNo: "9988776655",
  //     mailId: "name@gmail.com",
  //     availableDate: "25/12/04",
  //     availableTime: "15:00",
  //     officialComments: "Quick meet",
  //   },
  //   {
  //     officialName: "Kankam",
  //     officialId: "af3473",
  //     phoneNo: "9988776655",
  //     mailId: "name@gmail.com",
  //     availableDate: "20/12/04",
  //     availableTime: "10:00",
  //     officialComments: "30 mins meeting",
  //   },
  //   {
  //     officialName: "Kankam",
  //     officialId: "of7234",
  //     phoneNo: "9988776655",
  //     mailId: "name@gmail.com",
  //     availableDate: "01/12/04",
  //     availableTime: "22:00",
  //     officialComments: "vufvhbwdhj",
  //   },
  //   {
  //     officialName: "Jabili",
  //     officialId: "of6539",
  //     phoneNo: "9988776655",
  //     mailId: "name@gmail.com",
  //     availableDate: "20/11/04",
  //     availableTime: "12:00",
  //     officialComments: "be punctual",
  //   },
  //   {
  //     officialName: "Kankam",
  //     officialId: "of1362",
  //     phoneNo: "9988776655",
  //     mailId: "name@gmail.com",
  //     availableDate: "18/10/04",
  //     availableTime: "23:30",
  //     officialComments: "only civil cases",
  //   },
  // ];

  const handleAddEvent = (officialId,official_name) => {
    localStorage.setItem("official_id",officialId)
    localStorage.setItem("official_name",official_name)
    navigate(`/addevent`);
  };

  return (
    <div style={{ padding: "20px", backgroundColor: "#f9f9f9" }}>
      <h1>Official Calendar</h1>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "10px" }}>
              Official Name
            </th>
            <th style={{ border: "1px solid #ccc", padding: "10px" }}>
              Official ID
            </th>
            <th style={{ border: "1px solid #ccc", padding: "10px" }}>
              Phone No.
            </th>
            <th style={{ border: "1px solid #ccc", padding: "10px" }}>
              Mail ID
            </th>
            {/* <th style={{ border: "1px solid #ccc", padding: "10px" }}>
              Available Date
            </th>
            <th style={{ border: "1px solid #ccc", padding: "10px" }}>
              Available Time
            </th>
            <th style={{ border: "1px solid #ccc", padding: "10px" }}>
              Official Comments
            </th> */}
            <th style={{ border: "1px solid #ccc", padding: "10px" }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {tableData?.officials_availability?.map((row, index) => (
            <tr key={index}>
              <td style={{ border: "1px solid #ccc", padding: "10px" }}>
                {row.name}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "10px" }}>
                {row.id}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "10px" }}>
                {row.mobile_num}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "10px" }}>
                {row.email}
              </td>
              {/* <td style={{ border: "1px solid #ccc", padding: "10px" }}>
                {row.availableDate}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "10px" }}>
                {row.availableTime}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "10px" }}>
                {row.officialComments}
              </td> */}

              <td style={{ border: "1px solid #ccc", padding: "10px" }}>
                <button
                  onClick={() => handleAddEvent(row.officials_id,row.name)}
                  style={{
                    backgroundColor: "#007bff",
                    color: "white",
                    border: "none",
                    padding: "5px 10px",
                    cursor: "pointer",
                  }}
                >
                  Add Event
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OfficialCalendar;
